"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverlay = void 0;

var _useOnOutsideClick = require("./useOnOutsideClick");

var _useOpenAndCloseFocus = require("./useOpenAndCloseFocus");

var _useOnEscapePress = require("./useOnEscapePress");

var _useProvidedRefOrCreate = require("./useProvidedRefOrCreate");

const useOverlay = ({
  overlayRef: _overlayRef,
  returnFocusRef,
  initialFocusRef,
  onEscape,
  ignoreClickRefs,
  onClickOutside,
  preventFocusOnOpen
}) => {
  const overlayRef = (0, _useProvidedRefOrCreate.useProvidedRefOrCreate)(_overlayRef);
  (0, _useOpenAndCloseFocus.useOpenAndCloseFocus)({
    containerRef: overlayRef,
    returnFocusRef,
    initialFocusRef,
    preventFocusOnOpen
  });
  (0, _useOnOutsideClick.useOnOutsideClick)({
    containerRef: overlayRef,
    ignoreClickRefs,
    onClickOutside
  });
  (0, _useOnEscapePress.useOnEscapePress)(onEscape);
  return {
    ref: overlayRef
  };
};

exports.useOverlay = useOverlay;